<template>
  <div :class="['page', theme].join(' ')">
    <div
      :class="{ 'page-navbar': true, 'no-bottom-border': noBottomBorder }"
      v-if="hasNavbar"
    >
      <div
        v-if="hasClosed"
        class="navbar-left"
        @click="handleClose"
      >
        <slot name="navbar-left">
          <dok-icon
            class="header-left"
            name="left"
          />
        </slot>
      </div>
      <div
        v-else
        class="navbar-left"
      >
        <slot
          name="navbar-left"
          v-if="$slots['navbar-left']"
        />
        <dok-icon
          v-else
          class="header-left"
          name="left"
          @click="$router.back()"
        />
      </div>
      <div class="navbar-title">
        <slot name="navbar-title">{{ title }}</slot>
      </div>
      <div class="navbar-right">
        <slot name="navbar-right" />
      </div>
    </div>
    <div class="page-header">
      <slot name="page-header" />
    </div>
    <div
      class="page-content"
      :class="{ [stateClass[state]]: true, touch: touching }"
      @touchstart="handleTouchStart"
      @touchmove="handleTouchMove"
      @touchend="handleTouchEnd"
      @scroll="onScroll"
    >
      <slot />
      <footer
        class="load-more"
        :style="{display: enableInfinite && onInfinite ? '': 'none'}"
      >
        <slot name="load-more">
          <span v-show="downFlag === false">上拉加载更多</span>
          <span v-show="downFlag === true">加载中……</span>
        </slot>
      </footer>
      <div
        class="nullData"
        v-show="dataList && dataList.noFlag"
      >暂无更多数据</div>
    </div>
  </div>
</template>

<script>
import DokIcon from '../DokIcon'
import Scroll from './scroll'
import {callNativeAsyncFunc,NativeFuncs} from '../../utils/native'

export default {
  name: 'DokPage',
  mixins: [Scroll],
  components: { DokIcon },
  methods: {
    // 更新状态栏主题色
    initTheme() {
      if (this.hasNavbar) {
        const bgc = ['dark', 'black'].includes(this.theme) ? '#000000' : this.theme
        callNativeAsyncFunc(NativeFuncs.SYSTEM.STATUS_BAR_STYLE, {
          style: this.theme === 'light' ? 'black' : 'white',
          color: this.theme === 'light' ? '#000000' : '#ffffff',
          bgColor: this.theme === 'light' ? '#ffffff' : bgc
        })
      }
    },
    // 关闭 webview
    handleClose() {
      if (this.leftFunc) { this.leftFunc() } else { callNativeAsyncFunc(NativeFuncs.SYSTEM.CLOSE, {}, true) }
    }
  },
  mounted() {
    this.initTheme()
    this.hasMore = this.enableInfinite
  },
  watch: {
    theme() {
      this.initTheme()
    }
  }
}
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>
